/* eslint-disable max-len */
import {useState} from 'react';
import classNames from 'classnames';
import Avatar from '@/components/Avatar';
import {PowerListOption, VirtualUserProps} from '@/interface';
import {Role, DocRole, ShareInviteModalType, ShareInviteModalSource, MemberType} from '@/Constant';
import Checkbox from '@/components/Checkbox';
import Icon, {IconSize} from '@/components/Icon';
import {
    cantEditorDocRoleName,
} from '@/store/util';
import {
    SvgVideoPlay,
} from '@baidu/luffy-icon';
import styles from './css/searchListItem.module.scss';
import {GRAY_RELEASE_KEYS, initGray} from '@/grayRelease';
import ExternalLabel from '@/components/ExternalLabel';

const defaultMemberInfoMaxWidth = {
    groupUserHaveRoleOnDocOrRepo: 164,
    userHaveRoleOnDocAndRepo: 136,
    userHaveRoleOnDocOrRepo: 198,
    hoverGroupHaveRepoRole: 164,
};

    interface Iitems {
        isDept?: any;
        groupGuid?: string | undefined;
        spaceGuid?: string | undefined;
        isAdded?: boolean;
        isHandle?: boolean;
        gid?: number | string;
        name?: string | undefined;
        rlId?: any;
        memberGuid?: string;
        rocRoleName?: string;
        groupRoleName?: string;
        roleName?: string;
        repoRoleName?: string;
        memberType?: number;
        tenantId?: string | number | undefined;
        userGuid?: string;
        email?: string;
        id?: number;
        nickname?: string;
        avatar?: string;
        department?: string;
        status?: number;
        edit?: boolean;
        virtualUser?: VirtualUserProps;
        label?: string;
        // add
        randomId?: string;
        canAuth?: boolean;
        checked?: boolean;
        childrenMember?: [];
        openChildStatus?: boolean;

        // email
        emailGroupAddress?: string;
        hlEmailGroupAddress?: string;

        // externalRepo外部知识库字段
        passportId?: string;
        passportName?: string;
        mobile?: string;
        isExternalUser?: boolean;
        corpId?: number;
    }
    interface ICheckItemProps{
        itemData: Iitems;
        index: string;
        handleCheckBox: (itemData: Iitems, checked: boolean, index: string) => void;
        handleClickGroupBtn: (itemData: Iitems, openStatus: boolean) => void;
        powerListOptions?: PowerListOption[];
        shareInviteConfig: {
            source: string;
            type: string;
            displayType: string;
        };
        className?: string;
        isChild?: boolean;
        inputVal?: string;
        memberInfoMaxWidth?: {[index: string]: number};
        isRecently?: boolean;
        repository?: Repository;
    }

// eslint-disable-next-line complexity
export default function CheckItem(props: ICheckItemProps) {
    const {
        itemData,
        handleCheckBox,
        handleClickGroupBtn,
        shareInviteConfig,
        index,
        className,
        isChild = false,
        inputVal = '',
        isRecently,
        memberInfoMaxWidth = defaultMemberInfoMaxWidth,
        repository,
    } = props;

    // 标签展示
    const ROLE_MAP = {
        [`${Role.Owner}`]: '管理员',
        [`${Role.Admin}`]: '管理员',
        [`${Role.Member}`]: '成员',
        [`${Role.Reader}`]: '只读成员',
    };
    const DOC_ROLE_MAP = {
        [`${DocRole.Member}`]: '可编辑',
        [`${DocRole.Reader}`]: '可阅读',
        [`${DocRole.DocAdmin}`]: '页面管理员',
    };
    const isDepartment = shareInviteConfig.source === ShareInviteModalSource.department;
    const isEmailGroup = itemData.memberType === 15;

    const isRepository = shareInviteConfig.source === ShareInviteModalSource.repository;
    const isDocs = shareInviteConfig.source === ShareInviteModalSource.docs;
    const isRecentDocs = shareInviteConfig.source === ShareInviteModalSource.recentDocs;
    const isInvite = shareInviteConfig.type === ShareInviteModalType.invite;
    const isShow = shareInviteConfig.type === ShareInviteModalType.show;
    const isVUserLabel = itemData.virtualUser && itemData.virtualUser.label;
    const isExternalRepo = repository?.external;
    const isExternalUser = isExternalRepo && (!!itemData?.isExternalUser || itemData?.corpId !== 1 && itemData.memberType === MemberType.RlGroup);
    const [openStatus, setOpenStatus] = useState(false);
    const [openShow, setOpenShow] = useState(false);
    function handleChangeList(ev: any) {
        handleCheckBox(itemData, ev.target.checked, index);
    }
    // 点击展开
    function handleOpenGroups(ev: any) {
        ev.preventDefault();
        handleClickGroupBtn(itemData, !openStatus);
        setOpenStatus(!openStatus);
    }
    // 鼠标移入移出
    function onMouseLeaves() {
        setOpenShow(false);
    }
    function onMouseOvers() {
        setOpenShow(true);
    }
    // function showRoleName(val: boolean) {
    //     return val ?
    //         isDepartment && itemData?.roleName === 'isAAOwner' ?
    //             '负责人' : (itemData.roleName ? ROLE_MAP[itemData.roleName] : '') :
    //         itemData.rocRoleName ? DOC_ROLE_MAP[itemData.rocRoleName] : '';
    // }

    // eslint-disable-next-line complexity
    function showRoleName(val?: boolean) {
        let role = '';
        if (isDocs || isRecentDocs) {
            role = itemData.rocRoleName ? DOC_ROLE_MAP[itemData.rocRoleName] : '';
        }
        if (isDepartment) {
            if (itemData?.roleName === 'isAAOwner' || itemData?.roleName === 'isAAOwner') {
                role = '负责人';
            } else if (isChild) {
                role = itemData.groupRoleName ? ROLE_MAP[itemData.groupRoleName] : '';
            } else {
                role = itemData.roleName ? ROLE_MAP[itemData.roleName] : '';
            }
        }
        if (isRepository || val) {
            if (isChild) {
                role = itemData.repoRoleName ? ROLE_MAP[itemData.repoRoleName] : '';
            } else {
                role = itemData.roleName ? ROLE_MAP[itemData.roleName] : '';
            }
        }
        return role;
    }

    // 文档邀请需要根据当前登陆人的权限和勾选的权限判断能操作的权限
    function isDisabledItem() {
        // 文档： 高于自己权限的禁选
        // const isMemberAdmin = (itemData.rocRoleName === DocRole.Member || itemData.rocRoleName === DocRole.DocAdmin);
        // const abovePermissionDisabled = isMemberAdmin && !curUserCanUpdateAll() && !!curUserOnlyUpdateReader();
        const abovePermissionDisabled = !!itemData.rocRoleName && !cantEditorDocRoleName(itemData.rocRoleName);
        // 非文档：（知识库/部门） && 添加成员 && 已经存在权限 = 禁选
        const alreadyMemberDisabled = !!itemData.roleName || !!itemData.repoRoleName;
        return isDocs ? abovePermissionDisabled
            : (isRepository || isDepartment) && alreadyMemberDisabled;
    }
    let textStyle: any = null;
    if (isChild) {
        // 是群成员列表中的某一项且已经有权限
        (!itemData.gid
            && (itemData.roleName || itemData.rocRoleName || itemData.groupRoleName || itemData.repoRoleName))
            && (textStyle = {
                maxWidth: `${memberInfoMaxWidth.groupUserHaveRoleOnDocOrRepo}px`,
            });

        if (isVUserLabel || itemData.label) {
            textStyle = {
                maxWidth: '139px',
            };
        }
    } else {
        // 不是群成员列表
        // 知识库和页面权限都存在
        textStyle = showRoleName(isDocs || isRecentDocs) && (!itemData.gid && (itemData.rocRoleName))
            ? {
                maxWidth: `${memberInfoMaxWidth.userHaveRoleOnDocAndRepo}px`,
            }
            : (
            // 页面权限和知识库权限存在一种
                showRoleName(isDocs || isRecentDocs) ||
                    // eslint-disable-next-line max-len
                    (!itemData.gid && (itemData.roleName || itemData.rocRoleName || itemData.groupRoleName || itemData.repoRoleName))
                    ? {
                        maxWidth: (openShow && itemData.gid) ?
                            `${memberInfoMaxWidth.groupUserHaveRoleOnDocOrRepo}px`
                            : `${memberInfoMaxWidth.userHaveRoleOnDocOrRepo}px`,
                    }
                    : null
            );

        if (isVUserLabel || itemData.label || isExternalUser) {
            textStyle = {
                maxWidth: '160px',
            };
        }
    }

    // 把之前写在下面的逻辑搬了上来
    const isShowRoleName = !itemData.gid
        && (itemData.roleName || itemData.rocRoleName || itemData.groupRoleName || itemData.repoRoleName);

    function reTurnMemberOrLable() {
        if (isVUserLabel) {
            return <div className={'virtualtagwrap'}>
                <span className={'virtualtag'}>{isVUserLabel}</span>
            </div>;
        }
        if (itemData.label) {
            return <div className={'virtualtagwrap'}>
                <span className={'virtualtag'}>{itemData.label}</span>
            </div>;
        }

        return <>
            {
                isExternalUser ? <ExternalLabel labelName={'外部'} className={styles.externalLab} /> : null
            }
            <span className={
                ((isDocs || isRecentDocs) && !isChild)
                && showRoleName(
                    isDocs || isRecentDocs
                ) ? 'tags' : itemData?.isDept ? 'tags' : ''}
            >

                {
                    itemData?.isDept
                        ? '我的部门'
                        : ((isDocs || isRecentDocs) && !isChild)
                    && showRoleName(isDocs || isRecentDocs)
                }
            </span>
        </>;
    }
    const externalContent = (inputVal === itemData.mobile)
        ? `手机：${itemData.mobile || ''}` : itemData.passportName;

    return (
        <div
            className={styles.checkItemBox}
            onMouseLeave={onMouseLeaves}
            onMouseOver={onMouseOvers}
        >
            <Checkbox
                className={styles.checkItemNative}
                onChange={handleChangeList}
                // 不能选中的项如果已经是成员则checkbox的状态为选中
                checked={
                    (isRepository && itemData?.isDept && itemData?.isAdded) ||
                    itemData.checked
                    || (
                        !!isShowRoleName && isInvite && isDisabledItem()
                    )
                }
                // 文档邀请需要根据当前登陆人的权限和勾选的权限判断能操作的权限
                // 知识库层面添加部门内公开，如果已添加，则置灰不可选
                // 文档知识本层面添加部门内公开，添加后，依然可以重新选择赋予权限；如果无权限，则置灰不可选
                disabled={
                    isShow
                        ? false
                        : isInvite && isDisabledItem() || (isRepository && itemData?.isDept && itemData?.isAdded) ||
                            (itemData?.isDept && !itemData?.isHandle)}
            >
                <div className={classNames(className, styles.memberListItem)}>
                    <div className={styles.memberListItemLeft}>
                        {
                            itemData?.isDept ?
                                <Avatar
                                    size="sm"
                                    defaultText={itemData.name || itemData.nickname}
                                    groupGuid={itemData.groupGuid}
                                    spaceGuid={itemData.spaceGuid}
                                /> :
                                <Avatar
                                    size="sm"
                                    userGuid={itemData.userGuid}
                                    gid={itemData.gid}
                                    defaultText={itemData.name || itemData.nickname}
                                    emailGroup={isEmailGroup}
                                />
                        }
                        <div className={styles.memberListItemLeftInfo}>
                            <div className={styles.memberListItemLeftInfoTop}>
                                <div
                                    className={'textOverflow'}
                                    style={textStyle}
                                >
                                    <span className={'memberName'}>
                                        {isEmailGroup ?
                                            itemData.emailGroupAddress : (itemData.nickname || itemData.name)}
                                    </span>
                                    <span className={'memberDepartment'}>{itemData.department}</span>
                                </div>
                                {reTurnMemberOrLable()}
                            </div>
                            <span className={styles.memberListItemLeftInfoEmail}>
                                {
                                    isExternalUser
                                        ? externalContent
                                        : null
                                }
                                {
                                    isEmailGroup && !isExternalUser ?
                                        '邮件组' : itemData.gid ? `群号：${itemData.gid}` : itemData.email
                                }
                            </span>
                            <div className={styles.hoverBtn}>
                                {
                                    openShow && itemData.gid ?
                                        <div
                                            onClick={handleOpenGroups}
                                            className={styles.openGroupStyles}
                                        >
                                            <span>{openStatus ? '收起' : '展开'}</span>
                                            <Icon
                                                className={openStatus ? styles.openStatusIcon : styles.offStatusIcon}
                                                svg={SvgVideoPlay}
                                                size={IconSize.XXS}
                                            />
                                        </div>
                                        : null
                                }
                            </div>
                        </div>
                    </div>
                    {/* // 什么情况下展示权限信息 */}
                    {
                        isShowRoleName && !isShow ?
                            <div className={styles.alreadyAddspan}>
                                {/* 最近@人需要roleName字段 */}
                                {showRoleName()}
                            </div> :
                            null
                    }
                    {(isDocs && itemData?.isDept && itemData?.isAdded) &&
                    <div className={styles.alreadyAddspan}>{DOC_ROLE_MAP[itemData.roleName!]}</div> }
                </div>
            </Checkbox>
        </div>
    );
}
